import { stepStatuses } from '../../../constants'
import solicitude from './solicitude'
import needs from './needs'
import people from './people'
import info from './info'
import data from './data'
import activity from './activity'
import financial from './financial'

export default {
  [stepStatuses.SOLICITUDE]: solicitude,
  [stepStatuses.NEEDS]: needs,
  [stepStatuses.PEOPLE]: people,
  [stepStatuses.INFO]: info,
  [stepStatuses.DATA]: data,
  [stepStatuses.ACTIVITY]: activity,
  [stepStatuses.FINANCIAL]: financial
}
